import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { Form, InputGroup, Button } from "react-bootstrap";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import { API_BASE_URL, RECAPTCHA_SITE_KEY } from "@utils/constant";
import axios from "axios";
import ThankYou from "./thank-you";
import { Fade, Slide, Zoom } from "react-awesome-reveal";
import { RotatingLines } from "react-loader-spinner";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from "js-cookie";
import { triggerConversion, triggerEachFormTracker } from "@utils/helper";
import { COUNTRIES } from "@utils/contries";

const BrandForm: React.FC<any> = (props) => {
  const platformOptions = [
    {
      name: "Shopify",
      subName: [],
    },
    {
      name: "Woocommerce",
      subName: [],
    },
    {
      name: "Other",
      subName: ["Magento", "SalesForce", "PHP", "React"],
    },
  ];

  const { data, params } = props;
  const [isFirstForm, setIsFirstForm] = useState(true);
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, setValue, getValues } = useForm({});
  const recaptchaRef = React.useRef<ReCAPTCHA>();

  const [name, setName] = useState("");

  const [validated, setValidated] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState<any>({});
  const [formData, setFormData] = useState(null);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [subPlatformOptions, setSubPlatformOptions] = useState<string[]>([]);

  // Analytics
  useEffect(() => {
    const utmSource = new URL(window.location.href).searchParams.get(
      "utm_source"
    );
    if (utmSource && utmSource.trim() !== "") {
      Cookies.set("gokwik_utm_source", utmSource.toLowerCase(), {
        expires: 30,
      });
    }
  }, []);

  const handleRecaptchaChange = (value) => {
    formData.g_recaptcha_token = value;
    formData.form_type = "brand";
    axios
      .post(API_BASE_URL + "form/brand", formData)
      .then(function (response) {
        if (response.data.status === "ok") {
          triggerConversion();
          triggerEachFormTracker(formData)
        }

        setLoading(false);

        setErrors({});
        setName(formData?.name);
        setSuccessMessage("submitted");
      })
      .catch(function (error) {
        setLoading(false);

        console.log(error.response.data?.errors["product[]"]);
        setErrors(error?.response?.data?.errors);
      });
  };

  const handleRecaptchaSubmit = async () => {
    // Trigger the reCAPTCHA challenge
    recaptchaRef.current.execute();
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    if (!data.product) {
      data.product = [];
    }
    setLoading(true);
    setSuccessMessage("");

    data.source = params.get("utm_source");
    data.medium = params.get("utm_medium");
    data.campaign = params.get("utm_campaign");

    data.platform = getValues("platform");
    data.sub_platform = getValues("sub_platform");

    data.campaignid = params.get("campaignid");
    data.adgroupid = params.get("adgroupid");
    data.keyword = params.get("keyword");
    data.utm_term = params.get("utm_term");
    data.gad_source = params.get("gad_source");
    data.gad_campaignid = params.get("gad_campaignid");
    data.gbraid = params.get("gbraid");
    data.gclid = params.get("gclid");

    setFormData(data);
    handleRecaptchaSubmit();
  };

  return (
    <div className="form"  id="contact-form">
      <div className="contact-form-wrapper">
        {successMessage && (
          <Fade direction="right">
            <ThankYou name={name} />
          </Fade>
        )}

        {!successMessage && (
          <Fade direction="right">
            <Form
              onSubmit={handleSubmit(onSubmit)}
              noValidate
              validated={validated}
              name="brand"
            >
              <div className="col-12 mb-3">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Your Full Name*"
                >
                  <Form.Control
                    {...register("name")}
                    className={errors?.name ? "is-invalid" : ""}
                    type="text"
                    placeholder="Your Full Name*"
                  />
                  {errors?.name && (
                    <Form.Control.Feedback type="invalid">
                      {errors?.name[0]}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </div>

              <div className="col-12 mb-3">
                <FloatingLabel controlId="floatingCountry" label="Country*">
                  <Form.Select
                    {...register("country", { required: true })}
                    className={errors?.country ? "is-invalid" : ""}
                    onChange={(e) => setValue("country", e.target.value)}
                    style={{
                      height: "fit-content",
                      padding: "0.5rem 1rem 0 0.75rem",
                    }}
                  >
                    <option value="">Select Country</option>
                    {COUNTRIES.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </Form.Select>
                  {errors?.country && (
                    <Form.Control.Feedback type="invalid">
                      Country is required.
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </div>

              <div className="col-12 mb-3">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Your Mobile Number*"
                >
                  <Form.Control
                    {...register("mobile")}
                    className={errors?.mobile ? "is-invalid" : ""}
                    type="tel"
                    maxLength={15}
                    onKeyUp={(e) =>
                      setValue(
                        "mobile",
                        getValues("mobile").replace(/[^0-9]/g, "")
                      )
                    }
                    placeholder="Your Mobile Number*"
                  />

                  {errors?.mobile && (
                    <Form.Control.Feedback type="invalid">
                      {errors?.mobile[0]}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </div>

              <div className="col-12 mb-3">
                <FloatingLabel controlId="floatingInput" label="Your Email Id">
                  <Form.Control
                    {...register("email")}
                    className={errors?.email ? "is-invalid" : ""}
                    type="text"
                    placeholder="Your Email Id"
                  />

                  {errors?.email && (
                    <Form.Control.Feedback type="invalid">
                      {errors?.email[0]}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </div>

              <div className="col-12 mb-3">
                <FloatingLabel
                  controlId="floatingInput"
                  label="Your Brand URL*"
                >
                  <Form.Control
                    {...register("brand_url")}
                    className={errors?.brand_url ? "is-invalid" : ""}
                    type="text"
                    placeholder="Your Brand URL*"
                  />

                  {errors?.brand_url && (
                    <Form.Control.Feedback type="invalid">
                      {errors?.brand_url[0]}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </div>

              <div className="col-12 mb-3 custom-box">
                <div className="col-12 mb-3">
                  <p>Products Interested In*</p>
                </div>
                <div className="col-12 mb-3 check-box-row">
                  <Form.Check // prettier-ignore
                    {...register("product")}
                    value="KwikCheckout and RTO"
                    type="checkbox"
                    id="default-checkbox"
                    label="KwikCheckout and RTO"
                  />
                  {/* <i class="fa-solid fa-info"></i> */}
                  <span>
                    <span>Fastest and most intelligent checkout solution</span>
                  </span>
                </div>
                <div className="col-12 mb-3 check-box-row">
                  <Form.Check // prettier-ignore
                    {...register("product")}
                    value="KwikChat"
                    type="checkbox"
                    id="KwikChat-checkbox"
                    label="KwikEngage and Kwikpass"
                  />
                  <span>
                    <span>End-to-end Whatsapp Commerce solution</span>
                  </span>
                </div>
                <div className="col-12 mb-3 check-box-row">
                  <Form.Check // prettier-ignore
                    {...register("product")}
                    value="Return Prime"
                    type="checkbox"
                    id="Return-Prime-default-checkbox"
                    label="Return Prime"
                  />
                  <span>
                    <span>
                      A Shopify App to Streamline returns and exchanges and
                      maximise revenue per return.
                    </span>
                  </span>
                </div>

                {errors?.product && (
                  <Form.Control.Feedback
                    type="invalid"
                    style={{ display: "block" }}
                  >
                    {errors.product}
                  </Form.Control.Feedback>
                )}
              </div>

              <div className="col-12 mb-3">
                <FloatingLabel controlId="floatingPlatform" label="Platform*">
                  <Form.Select
                    {...register("platform")}
                    className={errors?.platform ? "is-invalid" : ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedPlatform(value);
                      const sub =
                        platformOptions.find((p) => p.name === value)
                          ?.subName || [];
                      setSubPlatformOptions(sub);
                      setValue("platform", value);
                      setValue("sub_platform", ""); // Reset sub-platform
                    }}
                    style={{
                      height: "fit-content",
                      padding: "0.5rem 1rem 0 0.75rem",
                    }}
                  >
                    <option value="">Select Platform</option>
                    {platformOptions.map((platform) => (
                      <option key={platform.name} value={platform.name}>
                        {platform.name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors?.platform && (
                    <Form.Control.Feedback type="invalid">
                      {errors?.platform[0]}
                    </Form.Control.Feedback>
                  )}
                </FloatingLabel>
              </div>

              {selectedPlatform && subPlatformOptions.length > 0 && (
                <div className="col-12 mb-3">
                  <FloatingLabel
                    controlId="floatingSubPlatform"
                    label="Sub Platform*"
                  >
                    <Form.Select
                      {...register("sub_platform")}
                      className={errors?.sub_platform ? "is-invalid" : ""}
                      onChange={(e) => {
                        setValue("sub_platform", e.target.value);
                      }}
                      style={{
                        height: "fit-content",
                        padding: "0.5rem 1rem 0 0.75rem",
                      }}
                    >
                      <option value="">Select Sub Platform</option>
                      {subPlatformOptions.map((sub) => (
                        <option key={sub} value={sub}>
                          {sub}
                        </option>
                      ))}
                    </Form.Select>
                    {errors?.sub_platform && (
                      <Form.Control.Feedback type="invalid">
                        {errors?.sub_platform[0]}
                      </Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </div>
              )}

              <ReCAPTCHA
                ref={recaptchaRef as React.RefObject<ReCAPTCHA>}
                sitekey={RECAPTCHA_SITE_KEY}
                size="invisible"
                onChange={handleRecaptchaChange}
              />

              <button
                type="submit"
                className="btn btn-submit"
                disabled={loading}
              >
                Submit
                <RotatingLines
                  strokeColor="white"
                  strokeWidth="5"
                  animationDuration="0.75"
                  width="18"
                  visible={loading}
                />
              </button>
            </Form>
          </Fade>
        )}
      </div>
    </div>
  );
};
export default BrandForm;
